import { render, staticRenderFns } from "./ClinicConfig.vue?vue&type=template&id=33e44432"
import script from "./ClinicConfig.vue?vue&type=script&lang=js"
export * from "./ClinicConfig.vue?vue&type=script&lang=js"
import style0 from "./ClinicConfig.vue?vue&type=style&index=0&id=33e44432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports